export const PromoterType = {
  PRIMARY: 'PRIMARY',
  SECONDARY: 'SECONDARY',
  OTHER: 'OTHER',

  values: () => {
    return ['PRIMARY', 'SECONDARY', 'OTHER'];
  },
};
